type BodyPart = "Brain" | "Head" | "Head and Neck" | "Abdomen and Chest" | "Torso" | "WholeBody" | "Pelvis" | "Combination";

export function isBodyPart(value: string): value is BodyPart {
    return ['Head', 'Head and Neck', 'Abdomen and Chest', 'Torso', 'WholeBody', 'Pelvis', 'Combination'].includes(value);
}
export function getBodyPartImageLink(bodyPart: BodyPart): string {
    switch (bodyPart) {
        case "Brain":
            return "/img/brain-outline.svg";
        case "Head":
            return "/img/head-outline.svg";
        case "Head and Neck":
            return "/img/headneck-outline.svg";
        case "Abdomen and Chest":
            return "/img/torso-outline.svg";
        case "Torso":
            return "/img/torso-outline.svg";
        case "WholeBody":
            return "/img/body-outline.svg";
        case "Pelvis":
            return "/img/female-pelvis-outline.svg";
        case "Combination":
            return "/img/combination-outline.svg";
        default:
            return "";
    }
}
